// Audio has its own FastPubSub subject, but uses the same capture-time clock
// as video. All timestamps are microseconds on the sender's wall clock.
export const AUDIO_PACKET_CONFIG = 16;
export const AUDIO_PACKET_FRAME = 17;
const FRAME_HEADER_BYTES = 25;

export function audioConfigPacket(config, streamEpoch = 0) {
  const body = new TextEncoder().encode(JSON.stringify({
    codec: config.codec,
    sampleRate: config.sampleRate,
    numberOfChannels: config.numberOfChannels,
    description: config.description ? toBase64(new Uint8Array(config.description)) : undefined,
    streamEpoch
  }));
  const packet = new Uint8Array(body.byteLength + 1);
  packet[0] = AUDIO_PACKET_CONFIG;
  packet.set(body, 1);
  return packet;
}

export function decodeAudioConfig(packet) {
  try {
    const config = JSON.parse(new TextDecoder().decode(packet.slice(1)));
    if (config?.codec !== "opus" || !Number.isInteger(config.sampleRate) || !Number.isInteger(config.numberOfChannels) || !Number.isInteger(config.streamEpoch)) {
      throw new Error("unsupported audio configuration");
    }
    return config;
  } catch (error) {
    throw new Error(`invalid audio configuration: ${error?.message || String(error)}`);
  }
}

export function audioFramePacket(chunk, captureTimeUs) {
  const data = new Uint8Array(chunk.byteLength);
  chunk.copyTo(data);
  const packet = new Uint8Array(FRAME_HEADER_BYTES + data.byteLength);
  packet[0] = AUDIO_PACKET_FRAME;
  const view = new DataView(packet.buffer);
  view.setFloat64(1, chunk.timestamp);
  view.setFloat64(9, chunk.duration || 20_000);
  view.setFloat64(17, captureTimeUs);
  packet.set(data, FRAME_HEADER_BYTES);
  return packet;
}

export function decodeAudioFrame(packet) {
  if (packet.byteLength < FRAME_HEADER_BYTES) return undefined;
  const view = new DataView(packet.buffer, packet.byteOffset, packet.byteLength);
  return {
    timestamp: view.getFloat64(1),
    duration: view.getFloat64(9),
    captureTimeUs: view.getFloat64(17),
    data: packet.slice(FRAME_HEADER_BYTES)
  };
}

function toBase64(bytes) {
  let value = "";
  for (const byte of bytes) value += String.fromCharCode(byte);
  return btoa(value);
}

export function fromBase64(value) {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return bytes;
}
